<div class="grid-x grid-margin-x">
    <div class="cell small-6">
        <label>Urban flag location:</label>
    </div>
    <div class="cell small-6">
        <label class="cursor-pointer">
            <input type="text" name="isUrban" [(ngModel)]="seConfiguration.isUrban" />
        </label>
    </div>

    <div class="cell small-6">
        <label>Expedited flag location:</label>
    </div>
    <div class="cell small-6">
        <label class="cursor-pointer">
            <input type="text" name="isExpedited" [(ngModel)]="seConfiguration.isExpedited" />
        </label>
    </div>

    <div class="cell small-6">
        <label>Due date location:</label>
    </div>
    <div class="cell small-6">
        <label class="cursor-pointer">
            <input type="text" name="applicationDueDate" [(ngModel)]="seConfiguration.applicationDueDate" />
        </label>
    </div>

    <div class="cell small-6">
        <label>Approve by date location:</label>
    </div>
    <div class="cell small-6">
        <label class="cursor-pointer">
            <input type="text" name="applicationAproveAfterDate" [(ngModel)]="seConfiguration.applicationAproveAfterDate" />
        </label>
    </div>
</div>